export default "__VITE_ASSET__Cd7tHz8O__"